import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Alert } from "reactstrap";
import PromoItem from "../../components/promoItem";
import UserWelcome from "../../components/userWelcome";
import UserStatementsGraph from "../../components/userStatementsGraph";
import SubuserStatementsGraph from "../../components/subuserStatementsGraph";
import { StateContext } from "../../utils/context";
import TenantContext from "../../utils/tenantContext";
import UserHelpScoutBeacon from "../../components/userHelpScoutBeacon";
import SubUserHelpScoutBeacon from "../../components/subuserHelpScoutBeacon";
import ApplicationsWidget from "../../components/applicationsWidget";
import ZapierBot from "../../components/zapierBot";
import AvailablePlansSection from "../stripeSubscription/availablePlansSection";
import { canSubUserManageSubscription } from "../../utils/subscriptionUtils";


const Dashboard = () => {
  const {currentUser} = useContext(StateContext);
  const {tenant} = useContext(TenantContext);
  const [promoFeedbackCount, setPromoFeedbackCount] = useState(0);
  const [promoDownloadCount, setPromoDownloadCount] = useState(0);
  const showSubUserSubscription = canSubUserManageSubscription(currentUser, tenant);

  useEffect(() => {
    if (currentUser) {
      setPromoFeedbackCount(currentUser.promo_feedback_count);
      setPromoDownloadCount(currentUser.promo_download_count);
    }
  }, [currentUser]);

  return (
    <>
      <Row>
        <Col>
          <UserWelcome />
        </Col>
      </Row>
  
      <Row>
      {
        !currentUser.is_subscribed && <ApplicationsWidget />
      }
      </Row>

      {
        showSubUserSubscription &&
        <Row className="mb-3">
          <Col>
            <AvailablePlansSection hideWhenEmpty hideWhenSubscribed />
          </Col>
        </Row>
      }

      <ZapierBot />

      {/* <Helmet>
        <script type="text/javascript" id="zsiqchat">
        {
          `
            var $zoho=$zoho || {};
            $zoho.salesiq = $zoho.salesiq || {widgetcode: "siq6270a7b8910b7a583720e18a90b7c03cf25aefa50775b7049a6ed0778b6bf1a71a4a26938a23882340258d4c14a3ea89", values:{},ready:function(){}};
            var d=document;
            s=d.createElement("script");
            s.type="text/javascript";
            s.id="zsiqscript";
            s.defer=true;
            s.src="https://salesiq.zohopublic.eu/widget";
            t=d.getElementsByTagName("script")[0];
            t.parentNode.insertBefore(s,t);
          `
        }
        </script>
      </Helmet> */}

      {/* <Row>
        <Col>
          {
            (currentUser && currentUser.is_sub_user) && 
            <>
              <SubuserStatementsGraph />
              <SubUserHelpScoutBeacon />
            </>
          }
          {
            (currentUser && !currentUser.is_sub_user) && 
            <>
              <UserStatementsGraph />
              <UserHelpScoutBeacon />
            </>
          }
        </Col>
      </Row>
      <Row>
        <PromoItem
          itemIcon="ti-pie-chart"
          itemHeading="Promo download count"
          itemSubHeading="Total downloads"
          itemCount={promoDownloadCount}
          cardBg="#707cd2"
        />
        <PromoItem
          id="2"
          itemIcon="icon-cloud-download"
          itemHeading="Promo feedback count"
          itemSubHeading="Total feedbacks"
          itemCount={promoFeedbackCount}
          cardBg="#ff5050"
        />
      </Row> */}
    </>
  );
};

export default Dashboard;
